import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { useEffect, useRef } from "react";
import { getPaddleCheckoutAttributes } from "../../../../others/getPaddleCheckoutAttributes.js";
import { trackAnalyticsEvent } from "../../../../others/tracking.js";
import { useStores } from "../../../../store/stores.js";
const ChangePaymentDetailsPaddleFrame = observer(({ subscription, shouldRefetch = true, onComplete, onError })=>{
    const { accountV2Store } = useStores();
    const ref = useRef(null);
    const paddleSubscription = subscription;
    const { ecommerceSystemSubscriptionId } = subscription.data;
    const { paymentUpdateUrl } = subscription.data;
    const frameTarget = `paddle-change-details-frame-${ecommerceSystemSubscriptionId}`;
    useEffect(()=>{
        if (!ref.current || !paddleSubscription.Paddle || !paymentUpdateUrl) {
            return;
        }
        paddleSubscription.Paddle.Checkout.open({
            ...getPaddleCheckoutAttributes(),
            override: paymentUpdateUrl,
            frameTarget,
            successCallback: ()=>{
                trackAnalyticsEvent("change_payment_details_completed", {
                    ga: {
                        event_category: "account",
                        event_label: "Change payment details completed"
                    },
                    matomo: {
                        category: "account",
                        name: "Change payment details completed"
                    }
                });
                if (shouldRefetch) {
                    accountV2Store.fetchSubscriptionsAndLicenses().catch(()=>undefined);
                }
                onComplete?.();
            },
            errorCallback: (error)=>{
                trackAnalyticsEvent("change_payment_details_errored", {
                    ga: {
                        event_category: "account",
                        event_label: "Change payment details errored",
                        value: error?.message
                    },
                    matomo: {
                        category: "account",
                        name: "Change payment details errored"
                    }
                });
                onError?.(error?.message ?? "");
            }
        });
    }, [
        paddleSubscription.Paddle,
        paymentUpdateUrl,
        frameTarget
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: frameTarget,
        ref: ref
    });
});
export { ChangePaymentDetailsPaddleFrame };
